
























































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { Survey } from '../../model/api';
import { abacusBySurvey } from './abacus';
import Uri from 'urijs';
import Podium from './podium.vue';
import AppBase from '../common/base';

@Component({ components: { Podium }})
export default class Results extends AppBase {
    survey: Survey = <Survey>{};
    results: any = {};
    itemIndex: number = 0;
    transitionName = 'fade';
    sharingCode = null;
    
    ageRange1 = true;
    ageRange2 = true;
    ageRange3 = true;

    gender1 = true;
    gender2 = true;

    async created() {
        this.$store.commit('setLoading', true);

        let data = await this.$store.dispatch('loadSurvey', { slug: this.routeSlug });
        if (data) {
            this.survey = data.survey;
            this.results = abacusBySurvey(this.lang, this.survey, data.results[0].strippedData, data.stats, data.results[0].fbId);
            this.sharingCode = data.results[0].handle;
        }

        if (this.$route.query && this.$route.query.index) {
            this.itemIndex = Number(this.$route.query.index);
        }

        this.$store.commit('setLoading', false);
        this.$store.commit('setTheme', { theme: `results-${this.survey.slug}` });
    }

    get resultsY() {
        if (this.results.y2) {
            return [this.results.y2, this.results.y1];
        }
        return [this.results.y1];
    }

    get showActions() {
        return this.results.plots && this.results.plots.length > 1;
    }

    get disablePrev() {
        return this.itemIndex == 0;
    }

    get disableNext() {
        return this.itemIndex == this.results.plots.length - 1;
    }

    get routeSlug() {
        return this.$route.params.slug;
    }

    get partitometroLink() {
        return { name: this.results.scatterLink };
    }

    get plotDescription() {
        if (this.results.plots[this.itemIndex] == 'scatter')
            return this.results.scatterDescription;
        else if (this.results.plots[this.itemIndex] == 'rankings')
            return this.results.rankingsDescription;
        else if (this.results.plots[this.itemIndex] == 'podium')
            return this.results.podiumDescription;
        else
            return this.results.scoreDescription;
    }

    get levelsChartHeight() {
        let resultsNumber = this.results.y1.length;
        let rowHeight = this.results.levelsRowHeight;
        if (rowHeight) {
            return resultsNumber * rowHeight;
        }
        return resultsNumber * 60;
    }

    get showTexts() {
        if (this.results.scoreTitle) {
            return true;
        } else if (this.results.scoreDescription) {
            return true;
        } else if (this.results.scatterDescription) {
            return true;
        } else {
            return false;
        }
    }

    get fakeFilterResults() {
        /* TODO */
        if (!this.gender1) {    
            return [3, 2, 3, 3, 4, 3, 2, 2, 3, 2, 3, 3];
        }
        if (!this.ageRange1) {    
            return [3, 3, 2, 3, 4, 3, 2, 2, 3, 2, 4, 4];
        }
        return [4, 3, 3, 4, 2, 4, 3, 2, 3, 3, 4, 3];
    }

    isItemVisible(item: any) {
        return this.results.plots.indexOf(item) == this.itemIndex;
    }

    move(direction: number) {
        if (this.results.plots) {
            this.transitionName = direction == -1 ? 'slide-right-fade' : 'slide-left-fade';
            this.itemIndex += direction;
        }
    }

    onPrev() {
        if (!this.disablePrev) {
            this.move(-1);
            this.$router.push({ query: { index: <any>this.itemIndex }});
        }
    }

    onNext() {
        if (!this.disableNext) {
            this.move(1);
            this.$router.push({ query: { index: <any>this.itemIndex }});
        }
    }

    onShare() {
        var slug = this.$route.params.slug;
        var route = this.$router.resolve({
            name: 'survey-landing', params: { lang: this.lang, slug }, query: { r: this.sharingCode }});
        var href = new Uri(window.location.href).resource(route.href).toString();
        (<any>window).FB.ui({
            method: 'share',
            href: href
        }, async (response) => {
            if (response && !response.error_message) {
                await this.$store.dispatch('updateSurveyResultShare', { slug });
            }
        });
    }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/app/surveys/results.vue